module.exports = __webpack_public_path__ + "static/media/quick-pitch.24cc62a6.png";